<template>
  <div class="page-finance-detail">
    <div>
      <div class="titlestyle">
        <el-tag style="margin-right: 1em;">理财</el-tag>
        <span>{{ruleForm.prdName}}</span>
        <span>(产品代码：{{ruleForm.prdCode}})</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="基本信息"
          name="basicMsg"
        >
          <div>
            <el-form
              status-icon
              :model="ruleForm"
              ref="ruleForm"
              label-width="200px"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="产品名称:"
                    prop="prdName"
                  >
                    {{ruleForm.prdName}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="产品代码:"
                    prop="prdCode"
                  >
                    {{ruleForm.prdCode}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="产品状态:"
                    prop="status"
                  >
                    {{ruleForm.statusRes}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="起购金额(元):"
                    prop="purchaseAmounts"
                  >
                    {{ruleForm.purchaseAmounts|formatCurrency}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="投资期限(天):"
                    prop="investTerm"
                  >
                    {{ruleForm.investTerm}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="预期年化收益率:"
                    prop="expAnnualYield"
                  >
                    {{ruleForm.expAnnualYield}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="业绩比较基准:"
                    prop="performanceCriterion"
                  >
                    {{ruleForm.performanceCriterion}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="七日年化收益率:"
                    prop="weekAnnualYield"
                  >
                    {{ruleForm.weekAnnualYield|getFloat}}%
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="收益类型:"
                    prop="yieldType"
                  >
                    {{ruleForm.yieldTypeRes}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="风险等级:"
                    prop="riskLevel"
                  >
                    {{ruleForm.riskLevelRes}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="运作模式:"
                    prop="operationMode"
                  >
                    {{ruleForm.operationModeRes}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="投资资产类型:"
                    prop="investAssetClass"
                  >
                    {{ruleForm.investAssetClassRes}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="最新净值:"
                    prop="newsetNetValue"
                  >
                    {{ruleForm.newsetNetValue|getFloat}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="最新净值日期:"
                    prop="newsetNetValueDate"
                  >
                    {{ruleForm.newsetNetValueDate | formatDate}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="初始净值:"
                    prop="initialNetValue"
                  >
                    {{ruleForm.initialNetValue|getFloat}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="累计净值:"
                    prop="accumultedNetValue"
                  >
                    {{ruleForm.accumultedNetValue|getFloat}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="最近一次兑付收益率:"
                    prop="latestCashYield"
                  >
                    {{ruleForm.latestCashYield|getFloat}}%
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="购买递增金额(元):"
                    prop="increaseAmounts"
                  >
                    {{ruleForm.increaseAmounts|formatCurrency}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="单笔最高限额(元):"
                    prop="singleMaxAmounts"
                  >
                    {{ruleForm.singleMaxAmounts|formatCurrency}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="单人最高限额(元):"
                    prop="personnalMaximumSum"
                  >
                    {{ruleForm.personnalMaximumSum|formatCurrency}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="发售总额(元):"
                    prop="saleAmt"
                  >
                    {{ruleForm.saleAmt|formatCurrency}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="可售余额(元):"
                    prop="remainAmounts"
                  >
                    {{ruleForm.remainAmounts|formatCurrency}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="募集开始日:"
                    prop="ipoStartDate"
                  >
                    {{ruleForm.ipoStartDate | formatToM}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="募集结束日:"
                    prop="ipoEndDate"
                  >
                    {{ruleForm.ipoEndDate | formatToM}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="产品成立日:"
                    prop="establishDate"
                  >
                    {{ruleForm.establishDate | formatDate}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="产品到期日:"
                    prop="expireDate"
                  >
                    {{ruleForm.expireDate | formatDate}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="币种:"
                    prop="currencyTypeRes"
                  >
                    {{ruleForm.currencyTypeRes}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="是否可提前赎回:"
                    prop="isAdvRedeemRes"
                  >
                    {{ruleForm.isAdvRedeemRes}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="发行机构:"
                    prop="issueOrgCode"
                  >
                    {{ruleForm.issueOrgCode}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="管理信息"
          name="manageMsg"
        >
          <div>
            <el-form
              status-icon
              :model="ruleForm"
              ref="ruleForm"
              label-width="100px"
            >
              <el-row>
                <el-col :span="4">
                  <el-form-item
                    label="上下架状态:"
                    prop="sellStatus"
                  >
                    <span v-if="ruleForm.sellStatus==='0'">下架</span>
                    <span v-if="ruleForm.sellStatus==='1'">上架</span>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <button
                    type="button"
                    class="manageBut"
                    v-if="ruleForm.sellStatus==='0'&&functionList.indexOf(
          '326983273347256320')!='-1'"
                    @click=" isSales('1')"
                  >上架</button>
                  <button
                    type="button"
                    class="manageBut"
                    v-if="ruleForm.sellStatus==='1'&&functionList.indexOf(
          '326983273347256320')!='-1'"
                    @click=" isSales('0')"
                  >下架</button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">
                  <el-form-item
                    label="是否置顶:"
                    prop="userName"
                  >
                    <span v-if="ruleForm.topFlag==='0'">否</span>
                    <span v-if="ruleForm.topFlag==='1'">是</span>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <button
                    type="button"
                    class="manageBut"
                    v-if="ruleForm.topFlag==='0'&&functionList.indexOf(
          '326983429484417024')!='-1'"
                    @click=" isDisables('1')"
                  >置顶</button>
                  <button
                    type="button"
                    class="manageBut"
                    v-if="ruleForm.topFlag==='1'&&functionList.indexOf(
          '326983429484417024')!='-1'"
                    @click=" isDisables('0')"
                  >取消置顶</button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="产品简介:"
                    prop="prdDesc"
                  >
                    <el-input
                      v-model="ruleForm.prdDesc"
                      :autosize="{minRows:Math.ceil(descriptionCount/30)}"
                      type="textarea"
                      style="width:60%"
                      placeholder="请输入产品简介，不超过1000字"
                    ></el-input>
                    <button
                      type="button"
                      class="manageBut"
                      @click=" changeDesc"
                      v-if="functionList.indexOf(
          '326983362094534656')!='-1'"
                    >保存简介</button>
                    <p>{{descriptionCount}}/1000</p>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="functionList.indexOf(
          '326983497444724736')!='-1'"
          label="销售机构"
          name="saleOrgans"
        >
          <div class="fina-org">
            <el-tree
              disabled
              ref="tree"
              node-key="id"
              :props="{label: 'orgnName'}"
              :data="treeData"
              :default-expanded-keys="[topKey]"
              :default-checked-keys="selectedList"
              show-checkbox
            ></el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="产品附件"
          name="prdAccess"
        >
          <div class="addTitle">
            <yh-button
              size="small"
              @click="addAnnex"
              v-if="functionList.indexOf(
          '327745462517600256')!='-1'"
            >新增个性化附件</yh-button>
          </div>
          <div>
            <el-table
              border
              :data="AccessData"
              style="width: 100%"
            >
              <el-table-column
                prop="id"
                label="附件ID"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="attachmentType"
                label="附件类型"
                width="150"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.attachmentType==='common'">公共附件</span>
                  <span v-if="scope.row.attachmentType==='customerized'">个性化附件</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="attachmentName"
                label="附件名称"
                width="150"
              >
              </el-table-column>
              <el-table-column
                prop="fileName"
                label="文件名"
                width="150"
              >
              </el-table-column>
              <el-table-column
                prop="hasToRead"
                label="是否必读"
                width="150"
              >
                <template slot-scope="scope">
                  <span v-if="parseInt(scope.row.hasToRead)===0">否</span>
                  <span v-if="parseInt(scope.row.hasToRead)===1">是</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="displayOrder"
                label="展示顺序"
                width="150"
              >
              </el-table-column>
              <el-table-column
                prop="enableStatus"
                label="附件状态"
                width="150"
              ><template slot-scope="scope">
                  <span v-if="parseInt(scope.row.enableStatus)===0">禁用</span>
                  <span v-if="parseInt(scope.row.enableStatus)===1">启用</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                width="200"
              >
                <template slot-scope="scope">
                  {{scope.row.createTime | formatTime}}
                </template>
              </el-table-column>
              <el-table-column
                prop="createId"
                label="创建人ID"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="修改时间"
                width="200"
              >
                <template slot-scope="scope">
                  {{scope.row.updateTime | formatTime}}
                </template>
              </el-table-column>
              <el-table-column
                prop="updateId"
                label="修改人ID"
                width="200"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="230px"
              >
                <template slot-scope="scope">
                  <div class="feature-container">
                    <span
                      class="button--blue"
                      @click="previewFile(scope.row)"
                      v-if="functionList.indexOf(
          '327747100724662272')!='-1'"
                    >预览</span>
                    <span
                      :class="scope.row.enableStatus === '1'
                      ?'button--grey'
                      : scope.row.attachmentType === 'common'?'button--grey':'button--blue'"
                      @click="editAccessory(scope.row)"
                      v-if="functionList.indexOf(
          '327745707846635520')!='-1'"
                    >修改</span>
                    <span
                      :class="scope.row.enableStatus === '1'
                      ? 'button--grey'
                      : scope.row.attachmentType === 'common'?'button--grey':'button--red'"
                      @click='handleDelAccess(scope.row)'
                      v-if="functionList.indexOf(
          '327746195098931200')!='-1'"
                    >删除</span>
                    <span
                      class="button--blue"
                      v-if="scope.row.enableStatus==='0'&&functionList.indexOf(
          '327746369535840256')!='-1'"
                      @click=" isDisableAccess(scope.row ,'1')"
                    >启用</span>
                    <span
                      :class="scope.row.attachmentType === 'common'?'button--grey':'button--blue'"
                      v-if="scope.row.enableStatus==='1'&&functionList.indexOf(
          '327746369535840256')!='-1'"
                      @click=" isDisableAccess(scope.row ,'0')"
                    >禁用</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 新增个性化附件 -->
            <yh-dialog
              title="新增个性化附件"
              :close-on-click-modal="false"
              :visible.sync="visibleAdd"
              width="570px"
            >
              <el-form
                class="hide-error"
                label-width="100px"
                :model="addFormData"
                ref="addForm"
              >
                <el-form-item
                  label="文件名"
                  required
                  prop="fileName"
                  class="no-radius"
                >
                  <el-row>
                    <el-col :span="18">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="addFormData.fileName"
                        placement="top-end"
                        :open-delay="1000"
                        :disabled="addFormData.fileName.length < 15"
                      >
                        <el-input
                          readonly
                          placeholder="上传文件后，此栏自动显示"
                          style="width: 100%;"
                          :value="formatName(addFormData.fileName)"
                        ></el-input>
                      </el-tooltip>
                      <p>文件格式：pdf；文件大小：20MB以内</p>
                      <p style="color:red;">{{uploadTip}}</p>
                    </el-col>
                    <el-col :span="6">
                      <el-upload
                        class="upload-demo"
                        action="/wmsp/prd/file/save"
                        :on-change="fileAdd"
                        accept=".pdf"
                        :on-success="handleSuccess"
                        :on-progress="handleProgress"
                        :on-error="handleError"
                        :before-upload="handleBeforeUpload"
                        :show-file-list="false"
                        :headers="{
                          userId: userId,
                          token: token,
                        }"
                      >
                        <el-button
                          size="small"
                          type="primary"
                        >{{uploadText}}</el-button>
                        <div
                          slot="tip"
                          class="el-upload__tip"
                        >{{uploadStatus}}</div>
                      </el-upload>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item
                  label="文件大小(MB)"
                  prop="fileSize"
                >
                  <el-input
                    type="text"
                    v-model="addFormData.fileSize"
                    autofocus
                    readonly
                    placeholder="上传文件后，此栏自动显示"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="attachmentName"
                  label="附件名称"
                  required
                >
                  <el-input
                    type="text"
                    v-model="addFormData.attachmentName"
                    autofocus
                    placeholder="附件名称展示到外屏给客户，如：风险提示书"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="mustRead"
                  label="是否必读"
                  required
                >
                  <el-radio
                    v-model="addFormData.hasToRead"
                    label="0"
                  >否</el-radio>
                  <el-radio
                    v-model="addFormData.hasToRead"
                    label="1"
                  >是</el-radio>
                </el-form-item>
                <el-form-item
                  prop="displayOrder"
                  label="展示顺序"
                  required
                >
                  <el-input
                    type="text"
                    v-model="addFormData.displayOrder"
                    autofocus
                    placeholder="请输入数字，数字越大展示越靠前"
                  ></el-input>
                </el-form-item>
              </el-form>
              <section slot="footer">
                <el-button @click="visibleAdd=false">取消</el-button>
                <yh-button
                  type="primary"
                  @click="handleCheckClick"
                >提交</yh-button>
              </section>
            </yh-dialog>
            <!-- 修改个性化附件 -->
            <yh-dialog
              title="修改个性化附件"
              :close-on-click-modal="false"
              :visible.sync="visibleEdit"
              width="570px"
            >
              <el-form
                class="hide-error"
                label-width="100px"
                :model="editFormData"
                ref="editForm"
              >
                <el-form-item
                  label="文件名"
                  required
                  prop="fileName"
                  class="no-radius"
                >
                  <el-row>
                    <el-col :span="18">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="editFormData.fileName"
                        placement="top-end"
                        :open-delay="1000"
                        :disabled="editFormData.fileName.length < 15"
                      >
                        <el-input
                          placeholder="上传文件后，此栏自动显示"
                          readonly
                          v-model.trim="editFormData.fileName"
                          :value="formatName(editFormData.fileName)"
                          style="width: 100%;"
                        ></el-input>
                      </el-tooltip>
                      <p>文件格式：pdf；文件大小：20MB以内</p>
                      <p style="color:red;">{{uploadTip}}</p>
                    </el-col>
                    <el-col :span="6">
                      <el-upload
                        class="upload-demo"
                        action="/wmsp/prd/file/save"
                        :on-change="fileChange"
                        accept=".pdf"
                        :on-success="handleSuccess"
                        :on-progress="handleProgress"
                        :on-error="handleError"
                        :before-upload="handleBeforeUpload"
                        :show-file-list="false"
                        :headers="{
                        userId: userId,
                        token: token,
                      }"
                      >
                        <el-button
                          size="small"
                          type="primary"
                        >重新上传</el-button>
                        <div
                          slot="tip"
                          class="el-upload__tip"
                        >{{uploadStatus}}</div>
                      </el-upload>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item
                  label="文件大小(MB)"
                  prop="fileSize"
                >
                  <el-input
                    type="text"
                    v-model="editFormData.fileSize"
                    autofocus
                    readonly
                    placeholder="上传文件后，此栏自动显示"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="attachmentName"
                  label="附件名称"
                  required
                >
                  <el-input
                    type="text"
                    v-model="editFormData.attachmentName"
                    autofocus
                    placeholder="附件名称展示到外屏给客户，如：风险提示书"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="mustRead"
                  label="是否必读"
                  required
                >
                  <el-radio
                    v-model="editFormData.hasToRead"
                    label="0"
                  >否</el-radio>
                  <el-radio
                    v-model="editFormData.hasToRead"
                    label="1"
                  >是</el-radio>
                </el-form-item>
                <el-form-item
                  prop="displayOrder"
                  label="展示顺序"
                  required
                >
                  <el-input
                    type="text"
                    v-model="editFormData.displayOrder"
                    autofocus
                    placeholder="请输入数字，数字越大展示越靠前"
                  ></el-input>
                </el-form-item>
              </el-form>
              <section slot="footer">
                <el-button @click="visibleEdit=false">取消</el-button>
                <yh-button
                  type="primary"
                  @click="submitEditAccess"
                >提交</yh-button>
              </section>
            </yh-dialog>
          </div>
          <yh-pagination
            :page.sync="currentPage"
            :total="sumCount"
          />
        </el-tab-pane>
        <hr>
        <br>
        <div>
          <el-form
            status-icon
            :model="ruleForm"
            ref="ruleForm"
            label-width="200px"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="产品来源:"
                  prop="dataSourceRes"
                >
                  {{ruleForm.dataSourceRes}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="产品同步时间:"
                  prop="dataSynTime"
                >
                  {{ruleForm.dataSynTime | formatTime}}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="管理信息修改人:"
                  prop="updateUserName"
                >
                  {{ruleForm.updateUserName}}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="管理信息修改时间:"
                  prop="updateTime"
                >
                  {{ruleForm.updateTime | formatTime}}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tabs>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-param-reassign */

import { addNav, getFunctionList } from '@/mixins';

export default {
  name: 'FinancialDetail',
  mixins: [addNav, getFunctionList],
  data() {
    const getsessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      userId: getsessionData.userId,
      token: JSON.parse(sessionStorage.getItem('userToken')),
      activeName: 'basicMsg',
      ruleForm: {},
      selectedList: [],
      treeData: [],
      topKey: [],
      treeprops: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      functionList: [],
      AccessData: [],
      sumCount: 0,
      currentPage: 1,
      pageSize: 10,
      canupload: false,
      uploadText: '上传文件',
      uploadStatus: '',
      uploadTip: '',
      uploadFileObj: {},
      visibleAdd: false,
      addFormData: {
        fileName: '', // 文件名
        attachmentName: '', // 附件名
        hasToRead: '0',
        displayOrder: '',
        annex: '', // 附件
        fileSize: '',
      },
      visibleEdit: false,
      editFormData: {
        fileName: '', // 文件名
        attachmentName: '', // 附件名
        hasToRead: '',
        displayOrder: '',
        annex: '', // 附件
        fileSize: '',
        id: '',
      },
    };
  },
  filters: {
    getFloat(number) {
      // eslint-disable-next-line no-restricted-properties
      number = Math.round(number * Math.pow(10, 4)) / Math.pow(10, 4);
      number = Number(number).toFixed(4);
      return number;
    },
  },
  computed: {
    descriptionCount() {
      return this.ruleForm.prdDesc ? this.ruleForm.prdDesc.length : 0;
    },
  },
  watch: {
    activeName(v) {
      if (v === 'saleOrgans') {
        this.loadSaleOrgn();
      }
      if (v === 'prdAccess') {
        this.getAccessories();
      }
    },
    currentPage: {
      immediate: false,
      handler() {
        this.getAccessories();
        this.loadSaleOrgn();
        this.getAccessories();
      },
    },
  },
  activated() {
    if (this.$route.query.prdCode) {
      this.ruleForm.prdCode = this.$route.query.prdCode;
      this.getManageInfo();
    }
  },
  methods: {
    formatName(name) {
      if (name.length >= 15) {
        return `${name.slice(0, 10)}...`;
      }
      return name;
    },
    // 获取产品管理信息
    getManageInfo() {
      const params = {
        data: {
          prdCode: this.ruleForm.prdCode,
        },
      };
      return this.$_post(this.$API.getManageInfo, params).then((res) => {
        this.ruleForm = res.data.info;
      });
    },
    // 是否上下架
    isSales(status) {
      let str = '';
      const name = this.ruleForm.prdName;
      if (status === '1') {
        str = '上架';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.sales(status);
          })
          .catch(() => {});
      } else if (status === '0') {
        str = '下架';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.sales(status);
          })
          .catch(() => {});
      }
    },
    // 修改上下架状态
    sales(status) {
      const getsessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          sellStatus: status,
          prdCode: this.ruleForm.prdCode,
          updateUserid: getsessionData.userId,
          userName: getsessionData.userName,
          loginOrgnCode: getsessionData.orgnCode,
          loginOrgnName: getsessionData.orgnName,
        },
      };
      this.$_post(this.$API.changeSaleStatus, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success('成功');
          this.getManageInfo();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 是否置顶
    isDisables(status) {
      let str = '';
      const name = this.ruleForm.prdName;
      if (status === '1') {
        str = '置顶';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.disables(status);
          })
          .catch(() => {});
      } else if (status === '0') {
        str = '取消置顶';
        this.$confirm(`确定要${str}"${name}"?`, '提示', {
          confirmButtonText: `${str}`,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(() => {
            this.disables(status);
          })
          .catch(() => {});
      }
    },
    // 修改置顶状态
    disables(status) {
      const getsessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          topFlag: status,
          prdCode: this.ruleForm.prdCode,
          updateUserid: getsessionData.userId,
          userName: getsessionData.userName,
          loginOrgnCode: getsessionData.orgnCode,
          loginOrgnName: getsessionData.orgnName,
        },
      };
      this.$_post(this.$API.changeTopStatus, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success('成功');
          this.getManageInfo();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 修改描述
    changeDesc() {
      if (this.ruleForm.prdDesc && this.ruleForm.prdDesc.length > 1000) {
        this.$message.warning('产品简介不能超过1000个字符');
        return;
      }
      this.$confirm('确定要保存修改后的产品简介?', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        closeOnClickModal: false,
      })
        .then(() => {
          this.keepDesc();
        })
        .catch(() => {});
    },
    // 修改描述提交
    keepDesc() {
      const getsessionData = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          prdDesc: this.ruleForm.prdDesc,
          prdCode: this.ruleForm.prdCode,
          updateUserid: getsessionData.userId,
          userName: getsessionData.userName,
          loginOrgnCode: getsessionData.orgnCode,
          loginOrgnName: getsessionData.orgnName,
        },
      };
      this.$_post(this.$API.changeDesc, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success('成功');
          this.getManageInfo();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 销售机构加载机构树
    loadSaleOrgn() {
      const { orgnInheritSign } = JSON.parse(
        sessionStorage.getItem('sessionData'),
      );
      this.$_post(this.$API.getSaleOrgns, {
        data: {
          prdCode: this.ruleForm.prdCode,
          orgnInheritSign,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.treeData = this.disableTree([res.data.info]);
          this.selectedList = res.data.list.map(item => item.id);
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.selectedList);
            this.topKey = this.treeData[0]?.id;
          });
        }
      });
    },
    disableTree(tree) {
      return tree
        .map(node => ({
          ...node,
          disabled: true,
        }))
        .map((node) => {
          const deno = { ...node };
          if (deno.children) {
            deno.children = this.disableTree(deno.children);
          }
          return deno;
        });
    },
    // 获取产品附件列表
    getAccessories() {
      const params = {
        pageMessage: {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
        },
        data: {
          productCode: this.ruleForm.prdCode,
          productName: this.ruleForm.prdName,
          productType: this.ruleForm.prdType,
        },
      };
      return this.$_post(this.$API.accessoriesListQuery, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.AccessData = res.data.list;
          this.sumCount = res.sumCount;
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 预览附件
    previewFile(row) {
      this.addNav({
        path: '/annex-preview',
        query: {
          ...row,
        },
        name: '附件预览',
      });
    },
    // 新增/修改前检测
    checkFormData(dataName) {
      function lessThan(n) {
        return v => v.length <= n;
      }
      function OrderCheck() {
        return (v) => {
          const regPos = /^\d+$/;
          if (!regPos.test(v) || parseInt(v, 10).toString().length > 6) {
            return false;
          }
          return true;
        };
      }
      const rules = [
        {
          prop: 'fileName',
          message: this.$MSG.M0172,
        },
        {
          prop: 'attachmentName',
          message: this.$MSG.M0175,
          validations: [
            {
              message: this.$MSG.M0176,
              validate: lessThan(50),
            },
          ],
        },
        {
          prop: 'displayOrder',
          message: '请输入展示顺序',
          validations: [
            {
              message: '排序值仅支持0-999999范围内的整数',
              validate: OrderCheck(),
            },
          ],
        },
      ];
      return this.validate(rules, this[dataName]);
    },
    // 文件状态改变
    fileAdd(file) {
      console.log('file', file);
      this.addFormData.annex = file.raw;
      this.addFormData.fileName = file.name;
      this.addFormData.fileSize = (file.size / 1024 / 1024).toFixed(1);
    },
    fileChange(file) {
      this.editFormData.annex = file.raw;
      this.editFormData.fileName = file.name;
      this.editFormData.fileSize = (file.size / 1024 / 1024).toFixed(1);
    },
    handleSuccess(response) {
      this.canupload = true;
      this.uploadStatus = '上传成功';
      this.uploadFileObj = {
        ...response.data.info,
      };
    },
    handleProgress() {
      this.uploadText = '重新上传';
      this.uploadStatus = '上传中';
    },
    handleError() {
      this.uploadStatus = '上传失败';
    },
    handleBeforeUpload(file) {
      this.uploadTip = '';
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      const size = file.size / 1024 / 1024;
      if (extension !== 'pdf') {
        this.uploadTip = '上传文件格式不正确,仅支持pdf!';
        this.canupload = false;
        this.uploadStatus = '';
        return false;
      }
      if (size > 20) {
        this.uploadTip = '上传文件大小不能超过20M!';
        this.canupload = false;
        this.uploadStatus = '';
        return false;
      }
      return true;
    },
    // 新增按钮
    addAnnex() {
      Object.keys(this.addFormData).forEach((key) => {
        this.addFormData[key] = '';
      });
      this.addFormData.hasToRead = '0';
      this.visibleAdd = true;
      this.uploadStatus = '';
      this.uploadTip = '';
      this.uploadText = '上传文件';
    },
    // 新增确定
    handleCheckClick() {
      if (!this.checkFormData('addFormData')) {
        return;
      }
      if (!this.canupload) {
        this.$message.error('请上传文件，等待文件上传成功');
      } else {
        const parames = {
          data: {
            ...this.uploadFileObj,
            ...this.addFormData,
            fileId: this.uploadFileObj.id,
            productCode: this.ruleForm.prdCode, // 产品代码
            productName: this.ruleForm.prdName, // 产品名称
            attachmentType: 'customerized', // 附件类型
            productType: this.ruleForm.prdType, // 产品类型
          },
        };
        // 先上传文件，再上传附件
        this.$_post(this.$API.addAccessory, parames)
          .then((res) => {
            if (res.errorCode === this.$CODE.success) {
              // 上传附件
              this.$message.success(`${this.$MSG.M0178}`);
              this.visibleAdd = false;
              this.getAccessories();
            }
          })
          .catch((res) => {
            this.$message.warning(res.errorMsg);
          });
      }
    },
    // 修改按钮
    editAccessory(row) {
      if (row.attachmentType === 'common' || row.enableStatus === '1') {
        return;
      }
      Object.keys(this.editFormData).forEach((key) => {
        this.editFormData[key] = row[key];
      });
      this.canupload = true;
      this.visibleEdit = true;
      this.uploadStatus = '';
      this.uploadTip = '';
    },
    // 修改确定
    submitEditAccess() {
      if (!this.checkFormData('editFormData')) {
        return;
      }
      if (!this.canupload) {
        this.$message.error('请上传文件，等待文件上传成功');
      } else {
        this.uploadStatus = '';
        this.uploadTip = '';
        this.$_yh_confirm('确定要修改该个性化附件吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.editAccess();
        });
      }
    },
    // 修改提交
    editAccess() {
      const parames = {
        data: {
          ...this.uploadFileObj,
          ...this.editFormData,
          fileId: this.uploadFileObj.id,
          productType: this.ruleForm.prdType, // 产品类型
        },
      };
      this.$_post(this.$API.updateAnnex, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success('修改成功');
          this.visibleEdit = false;
          this.getAccessories();
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
    // 删除按钮
    handleDelAccess(item) {
      if (item.attachmentType === 'common' || item.enableStatus === '1') {
        return;
      }
      this.$_yh_confirm(this.$MSG.M0190).then(() => {
        this.deleteAccess(item);
      });
    },
    // 删除确认
    deleteAccess(item) {
      const parames = {
        data: {
          id: item.id,
        },
      };
      return this.$_post(this.$API.delteAccessory, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success('删除成功');
          this.getAccessories();
        } else {
          this.$message({
            message: res.errorMsg,
            type: 'warning',
          });
        }
      });
    },
    // 是否修改附件的禁用启用状态
    isDisableAccess(row, status) {
      if (status === '1') {
        this.$confirm(
          '启用后，用户购买该产品时，外屏将显示该附件，确定要启用吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
          },
        )
          .then(() => {
            this.disablesAccess(row, status);
          })
          .catch(() => {});
      } else if (status === '0') {
        if (row.attachmentType === 'common') {
          return;
        }
        this.$confirm(
          '禁用后，用户购买该产品时，外屏将不再显示该附件，确定要禁用吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
          },
        )
          .then(() => {
            this.disablesAccess(row, status);
          })
          .catch(() => {});
      }
    },
    // 修改附件禁用启用的状态
    disablesAccess(row, status) {
      const params = {
        data: {
          enableStatus: status,
          id: row.id,
        },
      };
      this.$_post(this.$API.changeAccessStatus, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.currentPage = 1;
          this.getAccessories();
          this.$message.success('修改成功');
        } else {
          this.$message.warning(res.errorMsg);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.el-tab-pane {
  min-height: 500px;
}
.manageBut {
  margin-left: 50px;
  padding: 6px 16px;
  border: 1px solid #e4e7ed;
  background-color: #fff;
  border-radius: 6px;
  outline: none;
}
.prdType {
  display: inline-block;
  border: 1px solid #000;
  border-radius: 6px;
  padding: 2px 15px;
  margin-right: 6px;
}
.fina-org {
  min-height: 500px;
}
.titlestyle {
  font-size: 20px;
  margin-bottom: 10px;
}
.addTitle {
  text-align: right;
}
.el-tag {
  border-radius: 16px !important;
}
</style>
<style lang="scss">
.page-finance-detail {
  .el-form-item {
    margin-bottom: 0;
  }
  .yh-dialog .el-form-item {
    margin-bottom: 16px;
  }
  .yh-dialog .el-form {
    width: 525px;
    .el-upload__tip {
      color: red;
      margin-top: 0;
    }
  }
  .no-radius {
    label {
      transform: translate(0, 2px);
    }
    .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      height: 32px;
    }
    .el-button--small {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
